'use strict';

/**
 * Pict-Provider-RoutineStepAPI
 * ----------------------------
 * Browser-side CRUD client for RoutineStep, extending the generic EntityAPI
 * provider. Steps belong to a Routine (FK IDRoutine) and only ever render
 * inside the routine's step editor, so the one extra helper is listForRoutine:
 * the steps of one routine, sorted by SortOrder. Tenancy (IDCustomer) is
 * enforced server-side, so the client never sends it.
 */

const libPictProviderEntityAPI = require('./Pict-Provider-EntityAPI.js');
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'RoutineStepAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/',
	EntityName: 'RoutineStep',
	PluralRoute: 'RoutineSteps',
	IDField: 'IDRoutineStep'
};

class PictProviderRoutineStepAPI extends libPictProviderEntityAPI
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
	}

	/**
	 * The steps of one routine, sorted by SortOrder ascending.
	 * @param {number|string} pIDRoutine - the routine id
	 * @returns {Promise<Array<object>>}
	 */
	listForRoutine(pIDRoutine)
	{
		let tmpFilter = 'FBV~IDRoutine~EQ~' + pIDRoutine;
		return libFrameworkClient.getJSON(this.fable, this._url(this.pluralRoute + '/FilteredTo/' + tmpFilter + '/0/250'))
			.then((pBody) => Array.isArray(pBody) ? pBody : (pBody && pBody.Records) || [])
			.then((pRows) => pRows.sort((pA, pB) => (Number(pA.SortOrder) || 0) - (Number(pB.SortOrder) || 0)))
			.catch(() => []);
	}
}

module.exports = PictProviderRoutineStepAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
